import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first, map } from 'rxjs/operators';
import { AccountService } from 'src/app/_services/account.service';
import { AlertService } from 'src/app/_services/alert.service';
import { timer } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  hasError: boolean = false;
  errorValue: string;
  
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private allertService: AlertService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        username: ['', Validators.required],
        password: ['', Validators.required]
      }
    );

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  get f() { return this.form.controls; }

  resetError() {
    this.loading = false;
    this.submitted = false;
    this.hasError = false;
  }

  showError(error) {
    this.hasError = true;
    this.errorValue = error;

    let timer$ = timer(5000);
    timer$.subscribe(this.resetError);
  }

  login(){
    this.submitted = true;

    this.allertService.clear();

    if (this.form.invalid) {
      return;
    }

    this.loading = true;  

    this.accountService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(user => {
        this.loading = false;
        if (!user) {
          this.showError("User Name or Password not found. Please try again");
          return;
        }
        if (!user.hasOneOfRoles([1,2,3])) {
          this.showError("Access is denied.");
          this.accountService.logout();
          return;
        }
        this.router.navigate([this.returnUrl]);
      },
        error => {
          this.allertService.error(error);
          this.loading = false;
      });
  }
}
